export const DEFAULT_CALENDAR_HOUR_HEIGHT = 90
export const CALENDAR_EVENT_MIN_HEIGHT = 20
export const CALENDAR_OPENING_HOURS = Array.from({ length: 24 }, (_, index) => index)
